import { ErrorsService } from "src/app/services/common/errors.service";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

import { Validators } from "@angular/forms";
import { Component, OnInit, OnDestroy, Inject } from "@angular/core";
import { TranslateService } from "@ngstack/translate";
import { FormGroup, FormBuilder } from "@angular/forms";

import { IBranch } from "src/app/interfaces/branch";
import { SnackBarService } from "src/app/services/common/snackBar.service";
import { BranchService } from "src/app/services/http/business/branch/branch.service";
import { SoundEnum } from "src/app/enums/sound.enum";
import { BIDService } from "src/app/services/common/bid.service";
import { MatSelect } from "@angular/material";
import { CIDService } from "src/app/services/common/cid.service";
import { HoldingService } from "src/app/services/http/business/holding/holding.service";
import { CompanyService } from "src/app/services/http/business/company/company.service";
import { ICompany } from "src/app/interfaces/company";
import { ICash } from "src/app/interfaces/cash";
import { CashService } from "src/app/services/http/business/cash/cash.service";
import { IError } from "src/app/interfaces/error.interface";

@Component({
  selector: 'app-cash-entry',
  templateUrl: './cash-entry.component.html',
  styleUrls: ['./cash-entry.component.css'],
  providers: [ErrorsService]
})
export class CashEntryComponent implements OnInit, OnDestroy {
  param: any;
  errorList: IError[] = [];
  errObject: any;
  personInfo: any;
  isOwner: boolean;
  bracnchId: string;
  errors = new Array();
  companyList: ICompany[];
  branchesList: IBranch[];
  form: FormGroup;

  constructor(
    private fb: FormBuilder,
    private cidService: CIDService,
    private bidService: BIDService,
    private snackBar: SnackBarService,
    public translate: TranslateService,
    private errorService: ErrorsService,
    private branchSewrvice: BranchService,
    private companyService: CompanyService,
    private holdingService: HoldingService,
    private cashService: CashService,
    @Inject(MAT_DIALOG_DATA) public data: ICash,
    private dialogRef: MatDialogRef<CashEntryComponent>
  ) { }

  ngOnInit() {
    this.checkOwner();
    this.createCashForm();
    this.getCompanyList();
    console.log(this.data);
  }


  createCashForm() {
    this.form = this.fb.group({
      BranchEncryptId: [this.data.BranchEncryptId, Validators.compose([Validators.required])],
      Title: [this.data.Title, Validators.compose([Validators.required])],
      Id: [this.data && this.data.Id ? this.data.Id : 0]
    });
  }

  checkOwner() {
    this.holdingService.checkOwnerHolding().subscribe(res => {
      this.isOwner = res.IsOwner;
      if (res.IsOwner) {
        this.getCompanyList();
        this.bidService.setBID("");
      } else {
        this.getBranches();
      }
    });
  }

  getCompanyList() {
    this.companyService.list(0, 0).subscribe(res => {
      this.companyList = res.DataList;
    });
  }

  getBranches() {
    this.branchSewrvice.listByLogin(0, 0).subscribe(
      res => {
        this.branchesList = res.DataList;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  setCid(e: MatSelect) {
    this.cidService.setCID(e.value);
    this.getBranches();
  }

  submit(form: ICash) {
    this.errors = new Array();
    if (this.data.Id) {
      this.cashService.edit(form).subscribe(
        () => {
          this.dialogRef.close();

          this.snackBar.OpenSnackBar(
            this.translate.get("success.cashAdd"),
            "ok",
            5000,
            SoundEnum.beep
          );
        },
        err => {
          // this.errObject = this.errorService.getError(err);
          // this.param = this.errorService.objectError(this.errObject);
          // this.errors = this.errorService.returnError(err);
          this.errorList = this.errorService.getErrorList(err.error);
        }
      );
    }
    else {
      this.cashService.add(form).subscribe(
        () => {
          this.dialogRef.close();

          this.snackBar.OpenSnackBar(
            this.translate.get("success.cashAdd"),
            "ok",
            5000,
            SoundEnum.beep
          );
        },
        err => {
          // this.errObject = this.errorService.getError(err);
          // this.param = this.errorService.objectError(this.errObject);
          // this.errors = this.errorService.returnError(err);
          this.errorList = this.errorService.getErrorList(err.error);
        }
      );
    }

  }

  onNoClick() {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    if (this.isOwner) {
      this.bidService.setBID("");
    }
  }

}
